document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".repeat-block-faq-icon");

  faqItems.forEach(item => {
    const question = item.querySelector(".flex-icon-qusetion");
    const answer = item.querySelector(".answer-faq-shipping");
    const icon = item.querySelector(".icon-chevron-right svg");

    answer.style.maxHeight = "0px";
    answer.style.overflow = "hidden";
    answer.style.transition = "max-height 0.3s ease";

    question.addEventListener("click", () => {
      if (answer.style.maxHeight !== "0px") {
        answer.style.maxHeight = "0px";
        icon.classList.remove("active");
      } else {
        answer.style.maxHeight = answer.scrollHeight + "px";
        icon.classList.add("active");
      }
    });
  });
});